import * as yup from 'yup'

const piPunchDetails = {
    sellerPINumber : "",
    sellerPIDate : "",
    sellerPITotalAmount : "",
    //sellerPIDocProof : "",
    checked : false
}

const piPunchSchema = yup.object().shape({
    sellerPINumber: yup.string().when("checked", {
        is : false,
        then : () => yup.string().required('This Field is required').trim(),
        otherwise: () => yup.string()
        }),
    sellerPIDate: yup.string().when("checked", {
        is : false,
        then : () => yup.string().required('This Field is required').trim(),
        otherwise: () => yup.string().nullable()
    }),
    sellerPITotalAmount: yup.string().when("checked", {
        is : false,
        then : () => yup.string().required('This Field is required').trim(),
        otherwise : () => yup.string().nullable()
    }),
})

export { piPunchDetails, piPunchSchema }
